import { createDCHook } from '../../client';
import { getV1Smartthermostat } from '../../services/smartthermostat/DcSmartThermostatApiService';

export const useDcSmartThermostatApiGetV1Smartthermostat = createDCHook('getV1Smartthermostat', getV1Smartthermostat, {
  injectables: [],
  flattenData: false,
});
